import DataAccess from '@/libraries/DataAccess';

const state = {
    property: [],
    property_detail: [],
    property_list: [],
    general_question: []
}
const getters = {
    PROPERTY: state => {
        return state.property;
    },
    PROPERTYLIST: state => {
        return state.property_list;
    },
    PROPERTYDETAIL: state => {
        return state.property_detail;
    },
    GENERALQUESTION: state => {
        return state.general_question;
    }
}
const mutations = {
    SET_PROPERTY: (state, value) => {
        state.property = value;
    },
    ADD_PROPERTY: (state, value) => {
        state.property.push(value);
    },
    SET_PROPERTYLIST: (state, value) => {
        state.property_list = value;
    },
    ADD_PROPERTYLIST: (state, value) => {
        state.property_list.push(value);
    },
    UPDATE_PROPERTYLIST: (state, value) => {
        let data = value.detail;
        let index = value.index;
        
        state.property_list[index] = data;        
    },
    SET_PROPERTYDETAIL: (state, value) => {
        state.property_detail = value;
    },
    ADD_PROPERTYDETAIL: (state, value) => {
        state.property_detail.push(value);
    },
    SET_GENERAL_QUESTION: (state, value) => {
        state.general_question = value;
    }
}
const actions = {
    GET_PROPERTIES: async (context) => {
        let url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=SheetB";

        let data = await DataAccess.getResults(url);

        context.commit("SET_PROPERTY", data);
    },
    GET_GENERAL_QUESTION: async (context) => {
        let url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=Sheet1";

        let generalQuestion = await DataAccess.getResults(url);

        context.commit("SET_GENERAL_QUESTION", generalQuestion);
    },
    GET_PROPERTY: async (context) => {
        //let url = "http://cowmapdev/property/api/excel?sheetName=SheetB";

        let data = []; //await context.dispatch("GET_PROPERTIES");

        let property = [];

        context.dispatch("GET_PROPERTIES").then(() => {
            data = state.property;

            if (data) {
                for (let i = 0; i < data.length; i++) {
                    let p = [];
                    for (let j = 0; j < data[i].length; j++) {
                        p.push({ question: data[i][j], answer: "" });
                    }
                    property.push(p);
                }

                context.commit("SET_PROPERTY", property);
            }
        });
    },
    GET_PROPERTYDETAIL: async (context) => {
        let url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=Sheet1";

        let generalQuestion = await DataAccess.getResults(url);

        url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=SheetB";

        let data = await DataAccess.getResults(url); //await context.dispatch("GET_PROPERTIES"); // 

        // account info
        //url = "http://cowmapdev/property/api/excel?sheetName=SheetD";
        //let account = await DataAccess.getResults(url);

        let property = [];

        if (data) {

            for (let i = 0; i < data.length; i++) {
                let p = [];
                p.push({ question: data[i][0], answer: "" });
                p.push({ question: data[i][1], answer: "" });
                for (let k = 0; k < generalQuestion.length; k++) {
                    p.push({ question: generalQuestion[k][0], answer: "" });
                }
                for (let j = 2; j < data[i].length; j++) {
                    p.push({ question: data[i][j], answer: "" });
                }
                /*for (let l = 0; l < account[0].length; l++) {
                    p.push({ question: account[0][l], answer: "" });
                }*/
                property.push(p);
            }
            console.log(property);

            context.commit("SET_PROPERTYDETAIL", property);
        }
    },
    GET_PROPERTYLIST: async (context) => {
        let url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=Sheet1";

        let generalQuestion = await DataAccess.getResults(url);

        //context.dispatch("GET_GENERAL_QUESTION").then(() => {
        //    generalQuestion = state.general_question;
        //}); // DataAccess.getResults(url);

        url = process.env.VUE_APP_BEDP_API + "/api/excel?sheetName=SheetB";

        let data = await DataAccess.getResults(url); //await context.dispatch("GET_PROPERTIES"); // 

        // account info
        //url = "http://cowmapdev/property/api/excel?sheetName=SheetD";
        //let account = await DataAccess.getResults(url);

        let property = [];

        //context.dispatch("GET_PROPERTIES").then(() => {
        //    data = state.property;

            if (data) {
                
                for (let i = 0; i < data.length; i++) {
                    let p = [];
                    p.push({ question: data[i][0], answer: "" });
                    p.push({ question: data[i][1], answer: "" });
                    for (let k = 0; k < generalQuestion.length; k++) {
                        p.push({ question: generalQuestion[k][0], answer: "" });
                    }
                    for (let j = 2; j < data[i].length; j++) {
                        p.push({ question: data[i][j], answer: "" });
                    }
                    //for (let l = 0; l < account[0].length; l++) {
                    //    p.push({ question: account[0][l], answer: "" });
                    //}
                    // add meter info
                    //p.push({question: '14-digit MB Hydro account number', answer: ""});
                    //p.push({question: 'ELECTRIC Meter Number(s)', answer: ""});
                    //p.push({question: 'NATURAL GAS Meter Number(s)', answer: ""});
                    //p.push({question: 'Please list all active Manitoba Hydro account numbers and their associated electric and/or natural gas meter numbers. Note: more than one meter number may be associated with an account number.', answer: ""});

                    property.push(p);
                }
                console.log(property);

                context.commit("SET_PROPERTYLIST", property);
            }
        //});
        console.log(data);
    },
    SAVE_PROPERTY: async (context, value) => {
        // save property info

        context.commit("ADD_PROPERTY", value);
    },
    SAVE_PROPERTYLIST: async (context, value) => {
        context.commit("ADD_PROPERTYLIST", value);
    },
    EDIT_PROPERTYLIST: async (context, value) => {
        context.commit("UPDATE_PROPERTYLIST", value);
    }
}

export default {
    state, getters, mutations, actions
}